/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesPlayGameResponseLaunchDataOptions interface.
 */
export function instanceOfFxIdWebFeaturesPlayGameResponseLaunchDataOptions(value) {
    return true;
}
export function FxIdWebFeaturesPlayGameResponseLaunchDataOptionsFromJSON(json) {
    return FxIdWebFeaturesPlayGameResponseLaunchDataOptionsFromJSONTyped(json, false);
}
export function FxIdWebFeaturesPlayGameResponseLaunchDataOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'AppendToQuery': json['AppendToQuery'] == null ? undefined : json['AppendToQuery'],
    };
}
export function FxIdWebFeaturesPlayGameResponseLaunchDataOptionsToJSON(json) {
    return FxIdWebFeaturesPlayGameResponseLaunchDataOptionsToJSONTyped(json, false);
}
export function FxIdWebFeaturesPlayGameResponseLaunchDataOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'AppendToQuery': value['AppendToQuery'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesPlayGameResponseLaunchDataOptions.js.map